
function geoip(json){
  
  // Get country code based on IP
  var country_code = json.country_code;
  var country = json.country;
  var continent = json.continent_code;

  // ---------------------- September 2022 ------------------------ //

  var shipping = document.getElementsByClassName("shipping");
  
  var US = document.getElementsByClassName("US");
  var CA = document.getElementsByClassName("CA");
  var GB = document.getElementsByClassName("GB");
  var IE = document.getElementsByClassName("IE");
  var AU = document.getElementsByClassName("AU");
  var NZ = document.getElementsByClassName("NZ");
  var EU = document.getElementsByClassName("EU");
  var SG = document.getElementsByClassName("SG");
  var WORLD = document.getElementsByClassName("WORLD");

  // ----------------------------------------- US --------------------------------------------- //
  if (country_code == "US") {
    var US = document.getElementsByClassName("US");
    for (var i = 0; i < US.length; i++) { 
      US[i].style = "display: inline-block;" 
    }
    // --- hide ISO print options from U.S. customers
    var tcp_iso = document.getElementsByClassName("tcp_iso"); for (var i = 0; i < tcp_iso.length; i++) {  tcp_iso[i].style = "display: none; !important" }
  }
  
  // ----------------------------------------- United Kingdom --------------------------------------------- //
  if (country_code == "GB") {
    var GB = document.getElementsByClassName("GB");
    for (var i = 0; i < GB.length; i++) { 
      GB[i].style = "display: inline-block;" 
    }
  }
  
  // ----------------------------------------- Canada --------------------------------------------- //
  if (country_code == "CA") {
    var CA = document.getElementsByClassName("CA");
    for (var i = 0; i < CA.length; i++) { 
      CA[i].style = "display: inline-block;" 
    }
    // --- hide ISO print options from Canada customers
    var tcp_iso = document.getElementsByClassName("tcp_iso"); for (var i = 0; i < tcp_iso.length; i++) {  tcp_iso[i].style = "display: none; !important" }
  }
  
  // ----------------------------------------- Ireland --------------------------------------------- //
  if (country_code == "IE") {
    var IE = document.getElementsByClassName("IE");
    for (var i = 0; i < IE.length; i++) { 
      IE[i].style = "display: inline-block;" 
    }
  }
  
  // ----------------------------------------- Australia --------------------------------------------- //
  if (country_code == "AU") {
    var AU = document.getElementsByClassName("AU");
    for (var i = 0; i < AU.length; i++) { 
      AU[i].style = "display: inline-block;" 
    }
  }
  
  // ----------------------------------------- New Zealand --------------------------------------------- //
  if (country_code == "NZ") {
    var NZ = document.getElementsByClassName("NZ");
    for (var i = 0; i < NZ.length; i++) { 
      NZ[i].style = "display: inline-block;" 
    }
  }
  
  
  // ----------------------------------------- Europe, not Ireland or United Kingdom --------------------------------------------- //
  if (continent == "EU" && country_code != "IE" && country_code != "GB") {
    var NZ = document.getElementsByClassName("EU");
    for (var i = 0; i < EU.length; i++) { 
      EU[i].style = "display: inline-block;" 
    }
  }

  
  // ----------------------------------------- Not Europe or shipping countries --------------------------------------------- //
  if (continent != "EU" && country_code != "US" && country_code != "CA" && country_code != "AU" && country_code != "NZ" && country_code != "IE" && country_code != "GB") {
    var WORLD = document.getElementsByClassName("WORLD");
    for (var i = 0; i < WORLD.length; i++) { 
      WORLD[i].style = "display: inline-block;" 
    }
  } 

  

  
}



